import { formatTeacherFull } from '../../../utils/formatTeacher'

export const WINDOW_CLASS_TYPE_ID = 16

export function getLesson(item) {
    return item?.lessons?.[0] || item
}

export function getSubjectName(item, lesson) {
    return (
        item?.subject?.name
        || item?.subject_name
        || lesson?.subject_name
        || 'Без названия'
    )
}

export function getClassTypeName(item, lesson) {
    return (
        item?.class_type?.name
        || item?.class_type_name
        || lesson?.class_type_name
        || '—'
    )
}

export function getGroupName(item, lesson) {
    return item?.group?.name || item?.group_name || lesson?.group_name || '—'
}

export function getRoomName(item, lesson) {
    return item?.room?.name || item?.room_name || lesson?.room_name || '—'
}

export function isWindowLesson(item, lesson) {
    const typeId =
        lesson?.class_type_id
        || item?.class_type_id
        || item?.class_type?.class_type_id

    return Number(typeId) === WINDOW_CLASS_TYPE_ID
}

export function formatTeacherFromItem(item, lesson) {
    if (item?.teacher) return formatTeacherFull(item.teacher, '—')

    const fullName = `${item?.lastname || lesson?.lastname || ''} ${
        item?.firstname || lesson?.firstname || ''
    } ${item?.patronymic || lesson?.patronymic || ''}`.trim()

    return fullName || '—'
}
